import AffiliateAdministrationPage from './AffiliateAdministrationPage';
export default AffiliateAdministrationPage;